import { API_BASE_URL } from '../config/api';

/** Payment API host without `/api` suffix (e.g. https://bookapt-payment-api.onrender.com). */
export function getPaymentApiRoot(): string {
  return API_BASE_URL.endsWith('/api') ? API_BASE_URL.slice(0, -4) : API_BASE_URL;
}

export function buildFrontDeskLinks(businessId: string, businessName: string) {
  const apiRoot = getPaymentApiRoot();
  const encodedBusinessId = encodeURIComponent(businessId);
  const encodedBusinessName = encodeURIComponent(businessName || 'Your Business');
  return {
    bookingUrl: `${apiRoot}/b/${encodedBusinessId}?businessName=${encodedBusinessName}`,
    signUrl: `${apiRoot}/api/business/${encodedBusinessId}/front-desk-sign.pdf?businessName=${encodedBusinessName}`,
  };
}
